/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { globalNavActions } from './globalNavSlice'

export const { doneFetchingLinks, receiveGlobalNavLinks, startFetchingLinks } = globalNavActions
